// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/* eslint-disable */

import type * as Types from '../../../../../../../../schema';

import useSubscription from '@/client/hooks/useSubscription';
import gql from '@/shared/utils/gql';
export type SiteNotificationAddedSubscriptionVariables = Types.Exact<{
  input: Types.CasinoNotificationSiteNotificationAddedSubscriptionInput;
}>;


export type SiteNotificationAddedSubscription = { __typename?: 'Subscription', casinoNotificationSiteNotificationAdded?: { __typename?: 'CasinoNotificationSiteNotificationAddedSubscriptionPayload', clientSubscriptionId?: string, addedNotification?: { __typename?: 'CasinoNotificationSiteNotificationEdge', node?: { __typename?: 'CasinoNotificationMaintenanceNotification', id: string, eventTime?: number, site?: string, showForLoggedOutUsers?: boolean, showForLoggedInUsers?: boolean, createTime?: number, duration?: number, content?: Array<{ __typename?: 'CasinoNotificationMaintenanceNotificationContent', language?: string, text?: string, title?: string }> } } } };

export type SiteNotificationFragment = { __typename?: 'CasinoNotificationMaintenanceNotification', id: string, eventTime?: number, site?: string, showForLoggedOutUsers?: boolean, showForLoggedInUsers?: boolean, createTime?: number, duration?: number, content?: Array<{ __typename?: 'CasinoNotificationMaintenanceNotificationContent', language?: string, text?: string, title?: string }> };

export const SiteNotificationFragmentDoc = gql`
    fragment SiteNotificationFragment on CasinoNotificationMaintenanceNotification {
  id
  eventTime
  site
  showForLoggedOutUsers
  showForLoggedInUsers
  createTime
  duration
  content {
    language
    text
    title
  }
}
    `;
export const SiteNotificationAddedSubscriptionDocument = gql`
    subscription SiteNotificationAddedSubscription($input: CasinoNotificationSiteNotificationAddedSubscriptionInput!) {
  casinoNotificationSiteNotificationAdded(input: $input) {
    addedNotification {
      node {
        ...SiteNotificationFragment
      }
    }
    clientSubscriptionId
  }
}
    ${SiteNotificationFragmentDoc}`;

export const useSiteNotificationAddedSubscription = (options: { variables?: SiteNotificationAddedSubscriptionVariables, onData: (data: SiteNotificationAddedSubscription) => void } ) => { 
  return useSubscription<SiteNotificationAddedSubscription, SiteNotificationAddedSubscriptionVariables>(SiteNotificationAddedSubscriptionDocument, options);
}